import { useRef } from 'react';

type Function = (...args: any[]) => void;

export default function useDebounce<F extends Function>(func: F, timeout: number = 800) {
    const timer = useRef<NodeJS.Timeout>();

    return ((...args: unknown[]) => {
        clearTimeout(timer.current);

        timer.current = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    }) as (...P: Parameters<F>) => void;
}
